import * as React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import styled from 'styled-components';

import SensorDot from '../../ui/components/SensorDot';
import { fontWeights } from '../../ui/inline-styles/variables';
import { conditionToColor } from '../../utils/condition-to-color.util';
import { withLocale } from '../contexts/locale.context';
import { Condition } from '../enums/condition.enum';
import { Locale } from '../enums/locale.enum';
import { messages } from '../../../locale/messages';

interface Props {
  condition: Condition;
  locale: Locale;
}

const StIndexIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  & + & {
    margin: 0 0 0 32px;
  }
`;

const StIndexIndicatorName = styled.div`
  margin: 0 0 0 16px;
  opacity: 0.7;
  font-size: 1.5rem;
  font-weight: ${fontWeights.regular};
  color: #ffffff;
  text-transform: capitalize;
`;

class IndexIndicator extends React.Component<Props> {
  render() {
    const { condition, locale } = this.props;

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <StIndexIndicator>
          <SensorDot color={conditionToColor(condition)} />
          <StIndexIndicatorName>
            <FormattedMessage id={condition} />
          </StIndexIndicatorName>
        </StIndexIndicator>
      </IntlProvider>
    );
  }
}

export default withLocale(IndexIndicator);



// WEBPACK FOOTER //
// ./src/app/dashboard/components/IndexIndicator.tsx